import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-jornadas',
  templateUrl: './jornadas.component.html',
  styleUrls: ['./jornadas.component.scss']
})

export class JornadasComponent implements OnInit {
  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
